export const ORIGIN_ORDER_ENUM = [
  { value: 'ADMIN', label: 'admin' },
  { value: 'DTC_SWIFTER', label: 'dtc_swifter' },
  { value: 'DTC_WELLNESS', label: 'dtc_wellness' },
  { value: 'DTC_INSURANCE_QUOTE_FLOW', label: 'dtc_insurance_quote_flow' },
  { value: 'DTC_MEMBER_CENTER_UPSELL', label: 'dtc_member_center_upsell' },
  { value: 'DTC_INSURANCE_QUOTE_FLOW', label: 'dtc_insurance_quote_flow' },
  { value: 'WELLNESS_PARTNER_API', label: 'wellness_partner_api' },
  { value: 'GROUP_DTC', label: 'group_dtc' },
  { value: 'EMPLOYER', label: 'employer' },
];
